<template>
    <div class="com3" :class="{'bor':bor===true}">
        我是组件3
    </div>
</template>
<script>
export default {
    name: 'comThree',
    props: {
        bor: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss" scoped>
    .com3{
        height: 50px;
        background: yellow;
        color: #fff;
    }
    .bor{
        border: 2px solid green;
    }
</style>